import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const PercentageIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071C2.90237 20.3166 2.90237 19.6834 3.29289 19.2929L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289ZM4.5 6.5C4.5 5.39544 5.39544 4.5 6.5 4.5C7.60456 4.5 8.5 5.39544 8.5 6.5C8.5 7.60456 7.60456 8.5 6.5 8.5C5.39544 8.5 4.5 7.60456 4.5 6.5ZM15.5 17.5C15.5 16.3954 16.3954 15.5 17.5 15.5C18.6046 15.5 19.5 16.3954 19.5 17.5C19.5 18.6046 18.6046 19.5 17.5 19.5C16.3954 19.5 15.5 18.6046 15.5 17.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

PercentageIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(PercentageIcon);
